export default __webpack_public_path__ + "static/media/sign-upload-icon.e0599e24.svg";